import React, { useCallback } from 'react';
import { LFC } from '../../Legacy';
import { Button, usePrompt } from '../../ui';
import { Copy } from '../dashboard/elements/LayoutElements';
import { Popup, PopupProps } from '../popups/Popup';

export const createTeamLimitPopup = () => ({ ui: CreateTeamLimitPopup });

export const CreateTeamLimitPopup: LFC<PopupProps> = ({ dismiss }) => {

    const onBilling = useCallback(() => {
        window.open('/billing', '_blank');
        dismiss();
    }, [dismiss]);

    const promptRef = usePrompt({ ignoreEnter: true, onAction: dismiss });

    return <Popup ref={promptRef} w={32}>
        <Popup.Close onAction={dismiss} />
        <Popup.Title>Team Limit Reached</Popup.Title>
        <Popup.Content>
            <Copy>
                Sorry, you&apos;ve reached your limit of team spaces.
                Please update your plan quantity in the billing settings to create more teams.
            </Copy>
        </Popup.Content>
        <Popup.Actions>
            <Button variant="primary" onAction={onBilling}>
                Billing Dashboard
            </Button>
            <Button onAction={dismiss}>
                Cancel
            </Button>
        </Popup.Actions>
    </Popup>;
};
